module.exports = __webpack_public_path__ + "img/1002qhs2.10bcc36b.png";